<template>
  <div>
    <router-view name="header"></router-view>
    <router-view v-if="theChain" :key="key"></router-view>
    <div v-else>
      <el-result icon="warning" title="提示" subTitle="无权限访问">
        <template slot="extra">
          <el-button type="primary" size="medium" @click="$router.push('/zxk/home')">返回首页</el-button>
        </template>
      </el-result>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name:'RouterViewIndustry',
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
    key() {
      return this.$route.path
    },
    ...mapState({
      chainIDMap: state => state.asyncRoute.chainIDMap,
    }),
    ID() {
      return this.$route?.query?.id
    },
    theChain() {
      return this.chainIDMap[this.ID]
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.common-positive-negative {
  display: flex;
  align-items: center;
  padding: 2px 4px;
  background: #f7f8fa;
  font-size: 12px;
  border-radius: 2px;
  min-width: 78px;
  &.is-positive {
    color: #c81919;
  }
  &.is-negative {
    color: #009b37;
  }
}
</style>
